import React, {Component} from 'react';
import {Field, reduxForm, SubmissionError} from 'redux-form';
import {connect} from 'react-redux';
import Modal from '../UI/Modal';
import SelectField from '../Fields/SelectField';
import TextareaField from '../Fields/TextareaField';
import InputField from '../Fields/InputField';
import MediaItem from '../UI/MediaItem';
import {post, put as putMedia, setMediaItemForEdit, single} from '../../store/actions/media';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import BtnPrimary from "../UI/BtnPrimary";

class EditForm extends Component {
    submit(values) {
        const {scrollToTop, putMedia, item} = this.props;

        if (item && item.id) {
            if (!values.title || values.title === '') {
                scrollToTop();

                throw new SubmissionError({
                    title: 'Please enter title!'
                });
            }

            values.id = item.id;

            return putMedia(values);
        }
    }

    render() {
        const {id, workspace, handleSubmit, pristine, submitting, item} = this.props;

        return (
            <div key={id} className={classNamesPrefixed({'media-item-edit': true})}>
                <MediaItem item={item} clickableThumbnail={true}/>
                <form
                    className={classNamesPrefixed({'form': true, 'media-item-edit-form': true})}
                    onSubmit={handleSubmit(this.submit.bind(this))}
                >
                    {!submitting &&
                    <div>
                        <div className={classNamesPrefixed({'form-item': true, 'form-text': true})}>
                            <Field
                                name="title"
                                type="text"
                                label="Media title"
                                placeholder="Write media title"
                                component={InputField}
                                omitCollapsible={true}
                            />
                        </div>
                        <div className={classNamesPrefixed({'form-item': true, 'form-text': true})}>
                            <Field
                                name="fileName"
                                type="text"
                                label="Media file name"
                                placeholder="Write media file name"
                                component={InputField}
                                omitCollapsible={true}
                            />
                        </div>
                        <div className={classNamesPrefixed({'form-item': true, 'text-area': true})}>
                            <Field
                                name="description"
                                type="text"
                                label="Alt text"
                                placeholder="Write media alt description"
                                component={TextareaField}
                                omitCollapsible={true}
                            />
                        </div>
                        <div className={classNamesPrefixed({'form-actions': true})}>
                            {workspace && workspace.items.length > 0 &&
                            <div className={classNamesPrefixed({'form-item': true, 'form-select': true})}>
                                <Field
                                    defaultValue={{
                                        id: null,
                                        title: "All Workspaces"
                                    }}
                                    component={SelectField}
                                    label="Media available in workspace"
                                    id="workspaceId"
                                    name="workspaceId"
                                    items={workspace.items}
                                    omitCollapsible={true}
                                    clearable={true}
                                />
                            </div>
                            }
                            <BtnPrimary
                                disabled={pristine || submitting}
                                buttonType="submit"
                                icon={"save"}
                            >
                                Save
                            </BtnPrimary>
                        </div>
                    </div>
                    }
                </form>
            </div>
        )
    }
}

class MediaItemEditForm extends Component {
    componentDidMount() {
        const {id} = this.props;

        if (id) {
            this.setup(id);
        }
        document.addEventListener("keyup", this.handleKeyUp.bind(this));
    }

    componentWillUnmount() {
        document.removeEventListener("keyup", this.handleKeyUp.bind(this));
    }

    setup(id) {
        const {single} = this.props;

        if (id) {
            single(id);
        }
    }

    handleKeyUp(event) {
        const {media} = this.props;

        if (media && media.editItemId) {
            if (event.key === 'Escape') {
                this.closeMediaItemEdit();
            }
        }
    }

    closeMediaItemEdit() {
        const {setMediaItemForEdit} = this.props;

        setMediaItemForEdit(null);
    }

    render() {
        const {id, workspace, media} = this.props;

        return (
            <Modal
                title={"Edit media"}
                icon={"pencil"}
                outsideClickClose={true}
                onClose={(event) => this.closeMediaItemEdit(event)}
                showModal={media && media.editItemId && id === media.editItemId && media.item && media.item.data.id === media.editItemId}
            >
                {media.item &&
                <EditForm item={media.item.data} workspace={workspace}/>
                }

            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        workspace: state.workspace,
        submitting: state.submitting,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        post: (values) => dispatch(post(values)),
        putMedia: (values) => dispatch(putMedia(values)),
        setMediaItemForEdit: (id) => dispatch(setMediaItemForEdit(id)),
        single: (id) => dispatch(single(id))

    };
};

EditForm = reduxForm({form: 'MediaItemEditForm'})(EditForm);
EditForm = connect(mapStateToProps, mapDispatchToProps)(EditForm);
MediaItemEditForm = connect(mapStateToProps, mapDispatchToProps)(MediaItemEditForm);

export default MediaItemEditForm;



// WEBPACK FOOTER //
// ./src/core/admin/components/Forms/MediaItemEditForm.js